module.exports = __webpack_public_path__ + "img/logo.d3e14734.svg";